type Req<T> = (body: T | T[]) => Promise<boolean>;
interface Task<T> {
  body: T | T[];
  resolve: (result: boolean) => void;
}
interface Options<T> {
  request: Req<T>;
  delay?: number;
}

export class ReportTask<T> {
  private _taskQueue: Array<Task<T>>;
  private _timer: any;
  private _delay?: number;
  private _request: Req<T>;

  constructor(options: Options<T>) {
    this._taskQueue = [];
    this._request = options.request;
    this._delay = options.delay ?? 2000;
  }

  public run(task: { body: T | T[]; resolve: (result: boolean) => void }) {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._taskQueue.push(task);

    this._timer = setTimeout(() => {
      const runTask = this._taskQueue.splice(0);
      const params = runTask.reduce((prev, cur) => {
        if (Array.isArray(cur.body)) {
          return [...prev, ...cur.body];
        } else {
          return [...prev, cur.body];
        }
      }, [] as T[]);
      this._request(params).then((result) => {
        runTask.forEach((task) => {
          task.resolve(result);
        });
      });
      clearTimeout(this._timer);
    }, this._delay);
  }
}
